import {
  useModerationWindowSession,
  QUALIFICATION_TITLES,
} from "../constants/Constants";


const isRowComplete = (row, MAX_MARK) => {
  if (row.markAsAbsent || row.disableCandidate) return true;

  const marks =
    row.totalCriteriaAchieved ??
    row.existingTotalCriteriaAchieved;
  const assignment = row.assignment || row.assignmentId;

  const hasMarks =
    marks !== null &&
    marks !== undefined &&
    !(typeof marks === "string" && marks.trim() === "");

  if (!hasMarks || !assignment) return false;

  const num = Number(marks);
  if (isNaN(num) || num < 0 || num > MAX_MARK || /^0\d+$/.test(marks)) {
    return false;
  }
  return true;
};

const transformRows = (rows, location, selectedCenter) => {
  const unitCode = location.state.unit.split(" ")[0];
  const sesssionId = location.state.sessionId;
  let candidates = rows.map((row) => {
    if (row.markAsAbsent) {
      return {
        candidateNumber: row.candidateNumber.toString(),
        candidateName: row.candidateName,
        status: isRowComplete(row, row.totalMarks) ? "Complete" : "Incomplete",
        absent: true,
        totalNumberOfCriteriaAchieved: null,
        assignment: null,
      };
    }
    return {
      candidateNumber: row.candidateNumber.toString(),
      candidateName: row.candidateName,
      status: isRowComplete(row, row.totalMarks) ? "Complete" : "Incomplete",
      absent: false,
      totalNumberOfCriteriaAchieved: row.totalCriteriaAchieved
        ? Number(row.totalCriteriaAchieved)
        : null,
      assignment: row.assignment || row.assignmentId,
    };
  });

  return {
    centreName: selectedCenter.centerName,
    centreNumber: selectedCenter.centerNumber,
    unitNumber: unitCode,
    sessionId: sesssionId,
    stage: 1,
    candidates,
  };
};

const transformCriteriaRows = (
  rows,
  location,
  selectedCenter,
  subjectId,
  constants = {},
) => {
  const { mode, candidateDataMap } = constants || {};
  const unitCode = location.state.unit.split(" ")[0];
  const sesssionId = location.state.sessionId;
  let candidates = rows.map((row) => {
    let isAllCriteriaFilled =
      row && Array.isArray(row.criteria)
        ? row.criteria.every(
          (item) => item.achieved && item.achieved.trim() !== "",
        )
        : false;
    const { candidateMarks, achievedCount } =
      candidateDataMap[row.centreCandidateNumber] ||
      candidateDataMap[row.candidateNumber] ||
      {};

    return {
      candidateNumber: (
        row.candidateNumber || row.centreCandidateNumber
      ).toString(),
      status:
        mode === "view" ||
          (achievedCount == candidateMarks && isAllCriteriaFilled)
          ? "Complete"
          : "Incomplete",
    };
  });

  return {
    centreNumber: selectedCenter.centerNumber,
    unitNumber: unitCode,
    sessionId: sesssionId,
    subjectId: subjectId,
    candidates: candidates,
  };
};

const transformStage3UpdateTotalMarks = (rows, location, selectedCenter, isPostStage3 = false) => {
  const unitCode = location.state.unit.split(" ")[0];
  const sessionId = location.state.sessionId;

  let candidates = rows.map((row) => {
    if (row.markAsAbsent) {
      return {
        candidateNumber: row.candidateNumber.toString(),
        candidateName: row.candidateName,
        status: isRowComplete(row, row.totalMarks) ? "Complete" : "Incomplete",
        absent: true,

        ...(isPostStage3
          ? { lastSubmittedTotalMark: null }
          : { originalTotalNumberOfCriteriaAchieved: null }),

        updatedTotalNumberOfCriteriaAchieved: null,
        assignment: null,
      };
    }

    //  FIX: correct source + no falsy bug
    const original =
      row.existingTotalCriteriaScore ??
      row.existingTotalCriteriaAchieved;

    return {
      candidateNumber: row.candidateNumber.toString(),
      candidateName: row.candidateName,
      status: isRowComplete(row, row.totalMarks) ? "Complete" : "Incomplete",
      absent: false,

      ...(isPostStage3
        ? {
            lastSubmittedTotalMark:
              original !== null && original !== undefined
                ? Number(original)
                : null,
          }
        : {
            originalTotalNumberOfCriteriaAchieved:
              original !== null && original !== undefined
                ? Number(original)
                : null,
          }),

      updatedTotalNumberOfCriteriaAchieved:
        row.totalCriteriaAchieved !== null &&
        row.totalCriteriaAchieved !== undefined
          ? Number(row.totalCriteriaAchieved)
          : null,

      assignment: row.assignment || row.assignmentId,
    };
  });

  return {
    centreName: selectedCenter.centerName,
    centreNumber: selectedCenter.centerNumber,
    unitNumber: unitCode,
    sessionId,
    stage: 3,
    candidates,
    isPostStage3,
  };
};

const transformStage3ViewMarksRows = (rows, location, selectedCenter, isPostStage3 = false) => {
  const unitCode = location.state.unit.split(" ")[0];
  const sessionId = location.state.sessionId;

  let candidates = rows.map((row) => {
    if (row.markAsAbsent) {
      return {
        candidateNumber: row.candidateNumber.toString(),
        candidateName: row.candidateName,
        status: isRowComplete(row, row.totalMarks) ? "Complete" : "Incomplete",
        absent: true,

        ...(isPostStage3
          ? { lastSubmittedTotalMark: null }
          : { originalTotalNumberOfCriteriaAchieved: null }),

        updatedTotalNumberOfCriteriaAchieved: null,
        assignment: null,
      };
    }

    //  FIX: unified source
    const original =
      row.existingTotalCriteriaScore ??
      row.existingTotalCriteriaAchieved;

    return {
      candidateNumber: row.candidateNumber.toString(),
      candidateName: row.candidateName,
      status: isRowComplete(row, row.totalMarks) ? "Complete" : "Incomplete",
      absent: false,

      ...(isPostStage3
        ? {
            lastSubmittedTotalMark:
              original !== null && original !== undefined
                ? Number(original)
                : null,
          }
        : {
            originalTotalNumberOfCriteriaAchieved:
              original !== null && original !== undefined
                ? Number(original)
                : null,
          }),

      updatedTotalNumberOfCriteriaAchieved:
        row.totalCriteriaAchieved !== null &&
        row.totalCriteriaAchieved !== undefined
          ? Number(row.totalCriteriaAchieved)
          : null,

      assignment: row.assignment || row.assignmentId,
    };
  });

  return {
    centreName: selectedCenter.centerName,
    centreNumber: selectedCenter.centerNumber,
    unitNumber: unitCode,
    sessionId,
    stage: 3,
    candidates,
    isPostStage3,
  };
};

const transformStage3CriteriaRows = (marksArray, unitNumber, constants) => {
  const { mode, candidateDataMap } = constants || {};
  if (!Array.isArray(marksArray) || marksArray.length === 0) {
    return null;
  }

  const first = marksArray[0];

  // Group marks by candidateNumber
  const candidateMap = {};

  marksArray.forEach((m) => {
    if (!candidateMap[m.candidateNumber]) {
      candidateMap[m.candidateNumber] = [];
    }
    candidateMap[m.candidateNumber].push(m);
  });

  // Build candidate summary list
  const candidates = Object.entries(candidateMap).map(
    ([candidateNumber, criteriaMarks]) => {
      const isComplete = criteriaMarks.every(
        (crit) =>
          crit.assessmentCriteriaAchievedId !== null &&
          crit.assessmentCriteriaAchievedId !== undefined &&
          crit.assessmentCriteriaAchievedId !== "" &&
          crit.isValid,
      );

      return {
        candidateNumber: String(candidateNumber),

        status: isComplete ? "Complete" : "Incomplete",
      };
    },
  );

  return {
    centreNumber: String(first.centreNumber),
    unitNumber: unitNumber,
    sessionId: first.sessionId,
    subjectId: first.subjectId,
    candidates,
  };
};
export const getCenterType = (
  consortiaCentres,
  centreNumber,
  selectedSubject,
  selectedSubjectId
) => {
  if (!Array.isArray(consortiaCentres) || !centreNumber) {
    return "";
  }

  const matches = consortiaCentres.filter((c) => {
    const centreMatches = Number(c.centreNumber) === Number(centreNumber);

    const subjectMatches =
      Number(c.subjectId) === Number(selectedSubjectId) ||
      c.subjectName?.toLowerCase().trim() ===
        selectedSubject?.toLowerCase().trim();

    return centreMatches && subjectMatches;
  });

  if (!matches.length) return "";

  // ✅ Lead takes priority
  if (matches.some((c) => c.consortiaCentreType === "Lead")) {
    return "Lead";
  }

  // fallback
  if (matches.some((c) => c.consortiaCentreType === "Rest")) {
    return "Rest";
  }

  return "";
};

//For checking whether the assessment code is part of consortia units for the selected window
export const isConsortiaUnitForWindow = (
  assessmentCode,
  consortiaUnits,
  selectedWindow,
  moderationWindows,
) => {
  if (!consortiaUnits || !selectedWindow) return false;

  return consortiaUnits.some(
    (cu) =>
      cu.assessmentCode === assessmentCode &&
      (cu.sessionId === moderationWindows.window1 ? "window1" : "window2") ===
      selectedWindow,
  );
};
export const checkConsortiaUnitMix = (
  selectedUnits,
  consortiaUnits,
  moderationWindowSession,
  selectedWindow,
  isConsortium,
) => {
  if (!Array.isArray(selectedUnits) || !Array.isArray(consortiaUnits)) {
    return {
      isMixed: false,
      consortia: [],
      nonConsortia: [],
      isConsortiumRegistered: false,
    };
  }


  // 1. Get sessionId for the selected moderation window
  const selectedSessionId = moderationWindowSession[selectedWindow];

  // 2. Filter consortia units for this session
  const consortiaUnitsForWindow = consortiaUnits.filter(
    (u) => u.sessionId === selectedSessionId,
  );

  // 3. Build fast lookup set
  const consortiaUnitCodes = new Set(
    consortiaUnitsForWindow.map((u) => u.assessmentCode),
  );

  // 4. Split selected units
  const consortia = selectedUnits.filter((code) =>
    consortiaUnitCodes.has(code),
  );
 
  const nonConsortia = selectedUnits.filter(
    (code) => !consortiaUnitCodes.has(code),
  );

  // 5. Mixture condition
  const isMixed = consortia.length > 0 && nonConsortia.length > 0;
  //6.// If user selected "Yes" for consortium but selected units include non-consortia units
  const isConsortiumRegistered =
    isConsortium === "yes" && nonConsortia.length > 0;
  const isConsortiumUnitsSelected = selectedUnits.every((item) =>
    consortia.includes(item),
  );
 
  return {
    isMixed,
    consortia,
    nonConsortia,
    isConsortiumRegistered,
    isConsortiumUnitsSelected,
  };
};

export const getQualificationTitle = (subjects, selectedSubjectId) => {
  if (!subjects?.length) return "";

  const selected = subjects.find(
    (subj) => subj.subjectId === selectedSubjectId,
  );

  if (!selected) return "";

  const key = selected.qualificationShortName;
  return QUALIFICATION_TITLES[key] || "";
};
const getCentreNameByNumber = (dataArray, centreNumber) => {
  const centre = dataArray.find(item => item.orgId == centreNumber);
  return centre ? centre.name : "";
};
const transformRowsConsortia = (rowsInput, location, selectedCentres, consortiaCentres) => {
  const unitCode = location?.state?.unit?.split?.(" ")[0] || "";
  const sessionId = location?.state?.sessionId || "";

  // If already in final payload form, return normalized copy
  if (
    rowsInput &&
    typeof rowsInput === "object" &&
    Array.isArray(rowsInput.centres)
  ) {
    const centres = rowsInput.centres.map((c) => ({
      ...c,
      centreNumber:
        typeof c.centreNumber === "string" && /^\d+$/.test(c.centreNumber)
          ? Number(c.centreNumber)
          : c.centreNumber,
    }));
    return { centres };
  }

  // If caller passed an array of centre objects (each has candidates), just normalize numbers
  if (
    Array.isArray(rowsInput) &&
    rowsInput.length > 0 &&
    Array.isArray(rowsInput[0].candidates)
  ) {
    const centres = rowsInput.map((c) => ({
      ...c,
      unitNumber: c.unitNumber ?? unitCode,
      sessionId: c.sessionId ?? sessionId,
      centreNumber:
        typeof c.centreNumber === "string" && /^\d+$/.test(c.centreNumber)
          ? Number(c.centreNumber)
          : c.centreNumber,
    }));
    return { centres };
  }

  // If selectedCentres is actually the full centresData array (each item contains rows),
  // prefer that shape: flatten each centre's rows and use its metadata.
  if (
    Array.isArray(selectedCentres) &&
    selectedCentres.length > 0 &&
    selectedCentres[0] &&
    Array.isArray(selectedCentres[0].rows)
  ) {
    const centres = selectedCentres.map((cd) => {
      const centreNum =
        cd.selectedCenter?.centreNumber ??
        cd.selectedCenter?.centerNumber ??
        cd.centreNumber ??
        cd.centerNumber;


      const candidates = (cd.rows || []).map((row) => ({
        candidateNumber: String(row.candidateNumber ?? row.centreCandidateNumber ?? ""),
        candidateName: row.candidateName || "",
        status: isRowComplete(row, row.totalMarks) ? "Complete" : "Incomplete",
        absent: !!row.markAsAbsent,
        totalNumberOfCriteriaAchieved:
          row.markAsAbsent || row.totalCriteriaAchieved == null
            ? null
            : Number(row.totalCriteriaAchieved),
        assignment: row.assignment || row.assignmentId,
      }));
      return {
        centreName:
          cd.selectedCenter?.centreName ??
          cd.selectedCenter?.centerName ??
          cd.centreName ??
          cd.centerName ??
          "", // If no name found, it will default to an empty string
        centreNumber:
          typeof centreNum === "string" && /^\d+$/.test(centreNum)
            ? Number(centreNum)
            : centreNum,
        centreType:
          cd.centreType ??
          cd.selectedCenter?.centreType ??
          cd.selectedCenter?.centreType ??
          cd.centerType ??
          "",
        unitNumber: unitCode,
        sessionId: sessionId,
        stage: 1,
        candidates,
      };
    });


    return { centres };
  }

  // Otherwise treat rowsInput as an array of candidate rows: group them by centreNumber
  const centresMap = {};

  (Array.isArray(rowsInput) ? rowsInput : []).forEach((row) => {

    const centreKey = String(row.centreNumber ?? row.centerNumber ?? "");
    if (!centreKey) return;
    if (!centresMap[centreKey]) {
      centresMap[centreKey] = {
        centreName: getCentreNameByNumber(consortiaCentres, Number(row.centerNumber ?? centreKey)) || "", // Try to get centre name from consortiaCentres using the centre number
        centreNumber: row.centreNumber ?? row.centerNumber ?? centreKey,
        centreType: "",
        unitNumber: unitCode,
        sessionId: sessionId,
        stage: 1,
        candidates: [],
      };
    }
    centresMap[centreKey].candidates.push({
      candidateNumber: String(row.candidateNumber ?? row.centreCandidateNumber ?? ""),
      candidateName: row.candidateName || "",
      status: isRowComplete(row, row.totalMarks) ? "Complete" : "Incomplete",
      absent: !!row.markAsAbsent,
      totalNumberOfCriteriaAchieved:
        row.markAsAbsent || row.totalCriteriaAchieved == null
          ? null
          : Number(row.totalCriteriaAchieved),
      assignment: row.assignment || row.assignmentId || null,
    });
  });

  // Build final centres array and enrich with selectedCentres metadata when available
  const centresMetaArray = Array.isArray(selectedCentres)
    ? selectedCentres
    : selectedCentres && typeof selectedCentres === "object"
      ? [selectedCentres]
      : [];

  const transformedCentres = Object.values(centresMap).map((centreData) => {

    const meta =
      centresMetaArray.find((m) => {
        const metaNum =
          String(m.centreNumber ?? m.centerNumber ?? m.selectedCenter?.centreNumber ?? m.selectedCenter?.centreNumber);
        return String(metaNum) === String(centreData.centreNumber);
      }) || {};

    centreData.centreName =
      meta.centreName ??
      meta.centerName ??
      meta.selectedCenter?.centreName ??
      meta.selectedCenter?.centerName ??
      centreData.centreName;


    centreData.centreType =
      meta.centreType ??
      meta.centerType ??
      meta.selectedCenter?.centreType ??
      meta.selectedCenter?.centreType ??
      centreData.centreType;

    if (
      typeof centreData.centreNumber === "string" &&
      /^\d+$/.test(centreData.centreNumber)
    ) {
      centreData.centreNumber = Number(centreData.centreNumber);
    }

    return centreData;
  });

  return { centres: transformedCentres };
};



export const handleDownload = async (
  rows,
  type,
  location,
  selectedCenter,
  subjectData,
  api,
  constants,
  currentCentreType,
  isConsortiaUnit, centres,moderationWindowSession) => {

  let payload;
  if (type === "totalMarks") {
    if (currentCentreType === "Lead" && isConsortiaUnit) {
      payload = transformRowsConsortia(rows, location, selectedCenter, centres);
    } else {
      payload = transformRows(rows, location, selectedCenter);
    }
  } else {
    // For other types, use transformCriteriaRows
    payload = transformCriteriaRows(
      rows,
      location,
      selectedCenter,
      subjectData?.selectedSubjectId,
      constants,
    );
  }

  const { unit, sessionId } = location.state || {};
  try {
    let url;
    if (type === "totalMarks") {

      if (currentCentreType === "Lead" && isConsortiaUnit) {
        url = "consortia/downloadMarkSubmissionDataConsortia";
      } else {
        // Default for totalMarks but not a Lead Centre
        url = "downloadMarkSubmissionData";
      }
    } else {
      if (currentCentreType === "Lead" && isConsortiaUnit) {
        url = "downloadACMarksConsortia";
      } else {
        // For other types, use this default URL
        url = "downloadCriteriaMarkSubmissionData";
      }
    }

    const response = await api.post(url, payload);
    if (response.status === 200) {
      let csv = response.data;

      // Only transform the "Absent" column for total marks
      if (type === "totalMarks" && typeof csv === "string") {
        csv = convertAbsentToYesNo(csv);
      }

      const session =
  sessionId === moderationWindowSession.window1
    ? "window1"
    : "window2";
      const now = new Date();
      const pad = (n) => n.toString().padStart(2, "0");
      const timestamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(
        now.getDate(),
      )}${pad(now.getHours())}${pad(now.getMinutes())}`;
      const filename =
        type === "totalMarks"
          ? `TotalMarks_${unit.split(" ")[0]}_${session}_${timestamp}.csv`
          : `CriteriaMarks_${unit.split(" ")[0]}_${session}_${timestamp}.csv`;

      const blob = new Blob(["\uFEFF" + csv], {
        type: "text/csv;charset=utf-8;",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    } else {
      console.error("Failed to download marks", response);
    }
  } catch (error) {
    console.error("Error Downloading marks", error);
  }
};
const transformStage3UpdateTotalMarksConsortia = (
  rows,
  location,
  selectedCenter,
  isPostStage3 = false,
  centres,
  type,
  isConsortiaUnit = false
) => {
  const unitCode = location.state.unit.split(" ")[0];
  const sessionId = location.state.sessionId;

  const transformed = rows.map((row) => {
    const centreNumber = row.centreNumber || selectedCenter.centerNumber;
    const centreName = getCentreNameByNumber(centres, Number(row.centreNumber)) || "";

    const base = {
      candidateNumber: row.candidateNumber.toString(),
      candidateName: row.candidateName,
      status:
        type === "UpdatedViewTotalMarks"
          ? "Complete"
          : isRowComplete(row, row.totalMarks)
          ? "Complete"
          : "Incomplete",
      absent: !!row.markAsAbsent,
      centreNumber,
      centreName,
    };

    if (row.markAsAbsent) {
      return {
        ...base,
        ...(isPostStage3
          ? { lastSubmittedTotalMark: null }
          : { originalTotalNumberOfCriteriaAchieved: null }),
        updatedTotalNumberOfCriteriaAchieved: null,
        assignment: null,
      };
    }

    //  FIX HERE
    const original =
      row.existingTotalCriteriaScore ??
      row.existingTotalCriteriaAchieved;

    return {
      ...base,

      ...(isPostStage3
        ? {
            lastSubmittedTotalMark:
              original !== null && original !== undefined
                ? Number(original)
                : null,
          }
        : {
            originalTotalNumberOfCriteriaAchieved:
              original !== null && original !== undefined
                ? Number(original)
                : null,
          }),

      updatedTotalNumberOfCriteriaAchieved:
        row.totalCriteriaAchieved !== null &&
        row.totalCriteriaAchieved !== undefined
          ? Number(row.totalCriteriaAchieved)
          : null,

      assignment: row.assignment || row.assignmentId,
    };
  });

  const grouped = transformed.reduce((acc, candidate) => {
    const key = `${candidate.centreNumber}-${candidate.centreName}`;

    if (!acc[key]) {
      acc[key] = {
        centreName: candidate.centreName,
        centreNumber: candidate.centreNumber,
        unitNumber: unitCode,
        sessionId,
        stage: 3,
        isPostStage3,
        isConsortia: isConsortiaUnit,
        candidates: [],
      };
    }

    acc[key].candidates.push(candidate);
    return acc;
  }, {});

  return { centres: Object.values(grouped) };
};

const transformAssessmentCriteriaListConsortia = (rows, centres) => {
  if (!Array.isArray(rows) || rows.length === 0) return null;

  const unitNumber = rows[0].unitNumber;
  const sessionId = rows[0].sessionId;
  const subjectId = rows[0].subjectId;

  // 1. Group rows by centreNumber
  const centreMap = {};

  rows.forEach((row) => {
    const centreNumber = String(row.centreNumber);
    const centreName =
      getCentreNameByNumber(centres, Number(centreNumber)) || "";

    if (!centreMap[centreNumber]) {
      centreMap[centreNumber] = {
        centreName,
        centreNumber,
        unitNumber,
        sessionId,
        subjectId,
        stage: 3,
        candidates: {},
      };
    }

    // 2. Group rows by candidateNumber inside each centre
    if (!centreMap[centreNumber].candidates[row.candidateNumber]) {
      centreMap[centreNumber].candidates[row.candidateNumber] = [];
    }

    centreMap[centreNumber].candidates[row.candidateNumber].push(row);
  });

  // 3. Build final grouped structure
  const centresArray = Object.values(centreMap).map((centre) => {
    const candidateEntries = Object.entries(centre.candidates).map(
      ([candidateNumber, criteriaRows]) => {
        // 4. Compute status using your old logic
        const isComplete = criteriaRows.every(
          (crit) =>
            crit.assessmentCriteriaAchievedId !== null &&
            crit.assessmentCriteriaAchievedId !== undefined &&
            crit.assessmentCriteriaAchievedId !== "" &&
            crit.isValid
        );

        return {
          candidateNumber: String(candidateNumber),
          status: isComplete ? "Complete" : "Incomplete",
        };
      }
    );

    return {
      centreName: centre.centreName,
      centreNumber: centre.centreNumber,
      unitNumber: centre.unitNumber,
      sessionId: centre.sessionId,
      subjectId: centre.subjectId,
      stage: 3,
      candidates: candidateEntries,
    };
  });

  return { centres: centresArray };
};



export const handleDownloadStage3 = async (
  rows,
  type,
  location,
  selectedCenter,
  subjectData,
  api,
  constants = {},
  isPostStage3 = false,
  currentCentreType,
  isConsortiaUnit,
  centres,
  isStage3 = false,
  moderationWindowSession
) => {

  let payload;

  if (type === "UpdatedTotalMarks") {
    if (currentCentreType === "Lead" && isConsortiaUnit) {
      payload = transformStage3UpdateTotalMarksConsortia(rows, location, selectedCenter, isPostStage3, centres, "", isConsortiaUnit);
    } else {
      payload = transformStage3UpdateTotalMarks(rows, location, selectedCenter, isPostStage3);
    }
  } else if (type === "UpdatedViewTotalMarks") {
    if (currentCentreType === "Lead" && isConsortiaUnit) {
      payload = transformStage3UpdateTotalMarksConsortia(rows, location, selectedCenter, isPostStage3, centres, type, isConsortiaUnit);
    } else {
      payload = transformStage3ViewMarksRows(rows, location, selectedCenter, isPostStage3);
    }
  } else {
    // if(currentCentreType === "Lead" && isConsortiaUnit){
    //   payload = transformAssessmentCriteriaListConsortia(rows, centres);
    // } else
    payload = transformStage3CriteriaRows(
      rows,
      location.state.unit.split(" ")[0],
      constants,
    );
  }

  const { unit, sessionId } = location.state || {};
  try {
    const url = type === "UpdatedViewTotalMarks" || type === "UpdatedTotalMarks"
      ? ((currentCentreType === "Lead" && isConsortiaUnit)
        ? "consortia/downloadMarkSubmissionDataConsortia" : "downloadMarkSubmissionData") : 
        (currentCentreType === "Lead" && isConsortiaUnit && isStage3) ? 'downloadStage3ACMarksConsortia' : 'downloadStage3CriteriaMarkSubmissionData';


    const response = await api.post(url, payload);

    if (response.status === 200) {
      let csv = response.data;

      // Only transform the "Absent" column for total marks
      if (
        type === "UpdatedViewTotalMarks" ||
        (type === "UpdatedTotalMarks" && typeof csv === "string")
      ) {
        csv = convertAbsentToYesNo(csv);
      }

      const session =
  sessionId === moderationWindowSession.window1
    ? "window1"
    : "window2";
      const now = new Date();
      const pad = (n) => n.toString().padStart(2, "0");
      const timestamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(
        now.getDate(),
      )}${pad(now.getHours())}${pad(now.getMinutes())}`;
      const filename =
        type === "UpdatedViewTotalMarks" || type === "UpdatedTotalMarks"
          ? `UpdatedTotalMarks${isPostStage3 ? "2" :""}_${
              unit.split(" ")[0]
            }_${session}_${timestamp}.csv`
          : `UpdatedCriteriaMarks_${unit.split(" ")[0]}_${session}_${timestamp}.csv`;

      const blob = new Blob(["\uFEFF" + csv], {
        type: "text/csv;charset=utf-8;",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    } else {
      console.error("Failed to download marks", response);
    }
  } catch (error) {
    console.error("Error Downloading marks", error);
  }
};
export const getRegistrationKeys = (centreType, details) => {
  if (!centreType || centreType.trim() === "") {
    return {
      isRegistered: details?.isCandidateRegistered ?? null,
    };
  }

  if (centreType === "Lead") {
    return {
      isConsortiaLeadCandidateRegistered:
        details?.isConsortiaLeadCandidateRegistered ?? null,
      isConsortiaRestCandidateRegistered:
        details?.isConsortiaRestCandidateRegistered ?? null,
      isLeadCandidateRegistered: details?.isLeadCandidateRegistered ?? null,
    };
  }

  if (centreType === "Rest") {
    return {
      isConsortiaRestCandidateRegistered:
        details?.isConsortiaRestCandidateRegistered ?? null,
      isRestCandidateRegistered: details?.isRestCandidateRegistered ?? null,
    };
  }

  return {};
};

export const getRegistrationStatus = (centreType, details) => {
  if (!centreType || centreType.trim() === "") {
    // Neutral centre
    return details?.isCandidateRegistered ?? null;
  }

  if (centreType === "Lead") {
    const {
      isConsortiaLeadCandidateRegistered,
      isModerationVisit,
      isLeadCandidateRegistered,
    } = details || {};

    return (
      isConsortiaLeadCandidateRegistered === true ||
      isLeadCandidateRegistered === true
    );
  }

  if (centreType === "Rest") {
    const { isConsortiaRestCandidateRegistered, isRestCandidateRegistered } =
      details || {};

    // Example rule: if ANY rest key is true → registered
    return (
      isConsortiaRestCandidateRegistered === true ||
      isRestCandidateRegistered === true
    );
  }

  return null;
};


export const checkunitIsConsortiaUnit = (
  consortiaCentres,
  centerNumber,
  sessionId,
  assessmentCode,
) => {
  if (
    !Array.isArray(consortiaCentres) ||
    !centerNumber ||
    !sessionId ||
    !assessmentCode
  ) {
    return undefined;
  }

  const normalize = (v) =>
    String(v ?? "")
      .trim()
      .toUpperCase();

  const targetCode = normalize(assessmentCode);
  const targetCentre = Number(centerNumber);
  const targetSession = Number(sessionId);

  return consortiaCentres.some((c) => {
    return (
      Number(c.centreNumber) === targetCentre &&
      Number(c.sessionId) === targetSession &&
      normalize(c.assessmentCode) === targetCode
    );
  });
};

// Helper: convert Absent column values to Yes/No
function convertAbsentToYesNo(csv) {
  const lines = csv.split(/\r?\n/);
  if (lines.length === 0) return csv;

  // Find the Absent column index from the header
  const header = lines[0];
  const cols = splitCsvLine(header);
  const absentIdx = cols.findIndex((c) => c.trim().toLowerCase() === "absent");
  if (absentIdx === -1) return csv; // no Absent column, skip

  // Map each data line
  const out = [header];
  for (let i = 1; i < lines.length; i++) {
    const line = lines[i];
    if (!line.trim()) {
      out.push(line);
      continue;
    }
    const cells = splitCsvLine(line);
    if (absentIdx < cells.length) {
      const v = cells[absentIdx].trim().replace(/^"|"$/g, "");
      // Accept common representations: Y/N, true/false, 1/0
      const yes = v === "Y" || v === "y" || v === "true" || v === "1";
      const no = v === "N" || v === "n" || v === "false" || v === "0";
      // Only change when we recognize the value
      if (yes) cells[absentIdx] = "Yes";
      else if (no) cells[absentIdx] = "No";
      // Otherwise leave as-is
    }
    out.push(joinCsvLine(cells));
  }
  return out.join("\r\n");
}

// Minimal CSV split that respects quoted commas
function splitCsvLine(line) {
  const result = [];
  let cur = "";
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (ch === '"') {
      // Toggle quotes or handle escaped double quotes
      if (inQuotes && line[i + 1] === '"') {
        cur += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (ch === "," && !inQuotes) {
      result.push(cur);
      cur = "";
    } else {
      cur += ch;
    }
  }
  result.push(cur);
  return result;
}

function joinCsvLine(cells) {
  return cells
    .map((c) => {
      const needsQuotes = /[",\r\n]/.test(c);
      if (!needsQuotes) return c;
      return `"${c.replace(/"/g, '""')}"`;
    })
    .join(",");
}
